import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, clearSession, getEmail, getToken, setSession } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
    const [email, setEmail] = useState(getEmail());
    const [ready, setReady] = useState(false);

    useEffect(() => {
        const t = getToken();
        if (!t) {
            setReady(true);
            return;
        }
        api.get("/auth/me")
            .then((r) => setEmail(r.data.email))
            .catch(() => {
                clearSession();
                setEmail("");
            })
            .finally(() => setReady(true));
    }, []);

    const login = useCallback((token, emailAddr) => {
        setSession(token, emailAddr);
        setEmail(emailAddr);
    }, []);

    const logout = useCallback(() => {
        clearSession();
        setEmail("");
    }, []);

    return (
        <AuthCtx.Provider value={{ email, isAuthed: !!email, ready, login, logout }}>
            {children}
        </AuthCtx.Provider>
    );
};

export const useAuth = () => useContext(AuthCtx);
